import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import SectionGrid from '../components/ui/SectionGrid';
import BentoCard from '../components/ui/BentoCard';
import Stat from '../components/ui/Stat';
import ArcMark from '../components/ui/ArcMark';

const Home = () => (
  <div className="bg-canvas">
    <Seo
      path="/"
      description="ARQNXS is an Amsterdam technology company specialised in FinTech. It develops proprietary infrastructure and brings it to market as a product, through IP licensing, and via QuantNexus Capital."
    />

    <SectionGrid className="pt-2">
      <div className="col-span-6 md:col-span-4 bg-white border border-line rounded-tile p-8 md:p-12 flex flex-col justify-center min-h-[260px] md:min-h-[42vh]">
        <h1 className="text-navy text-3xl md:text-5xl font-medium leading-tight">
          Financial technology,
          <br />
          developed and owned.
        </h1>
        <p className="text-slate text-sm md:text-base mt-4 max-w-md leading-relaxed">
          An Amsterdam FinTech company — proprietary infrastructure as
          products, IP licenses, and self-operated DeFi technology.
        </p>
      </div>

      {/* Brand tile: arc cropped oversize, tonal navy-deep on navy. */}
      <div className="col-span-6 md:col-span-2 bg-navy rounded-tile relative overflow-hidden min-h-[160px]">
        <ArcMark className="absolute -right-10 -bottom-6 w-56 text-navy-deep" />
        <p className="text-bluegray-muted text-[10px] tracking-widest m-4 relative">
          EST. 2017 · AMSTERDAM
        </p>
      </div>

      <BentoCard
        span={2}
        label="Product"
        title="DojiPad"
        desc="Behavioral AI as a trading journal"
        href="/dojipad"
        className="min-h-[150px] md:min-h-[20vh]"
      />
      <BentoCard
        span={2}
        dark
        label="Operations"
        title="QuantNexus Capital"
        desc="Executive layer of our DeFi infrastructure"
        href="/quantnexus"
        className="min-h-[150px] md:min-h-[20vh]"
      />
      <BentoCard
        span={2}
        label="Licensing"
        title="IP under license"
        desc="Proven stack, run by external funds"
        href="/licensing"
        className="min-h-[150px] md:min-h-[20vh]"
      />

      <BentoCard
        span={4}
        label="Product"
        title="DojiPad Institutional"
        desc="Decision supervision for discretionary desks — mandate-aware, single tenant, zero data egress"
        href="/dojipad-institutional"
        className="min-h-[110px] md:min-h-[12vh]"
      />
      <div className="col-span-6 md:col-span-2 bg-white border border-line rounded-tile p-6 flex flex-col justify-center">
        <Link to="/work-with-us" className="text-navy text-sm font-medium">
          Work with us →
        </Link>
        <p className="text-slate text-[10px] mt-1">
          Trading · AI · defense · quant
        </p>
      </div>

      <div className="col-span-6 bg-tile rounded-tile p-6 flex flex-wrap gap-x-14 gap-y-4 items-center min-h-[110px] md:min-h-[12vh]">
        <Stat value="$1B+" label="on-chain volume" />
        <Stat value="NATO NSPA" label="registered" />
        <Stat value="5" label="countries" />
      </div>
    </SectionGrid>
  </div>
);

export default Home;
